import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TextSkeleton from '@src/components/TextSkeleton';
import { StyledReferralCode } from './index.style';
import CopyableButton from './CopyableButton';

const ReferralCodeItem = ({
  label,
  value,
  isEdit = false,
  onEdit,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <StyledReferralCode>
      <div className="item-wrapper">
        <div className="item-title">
          <Typography className="item-label">{label}</Typography>
          {isEdit && (
            <Typography className="edit-button" onClick={onEdit}>
              {t('edit')}
            </Typography>
          )}
        </div>
        <div className="item-value">
          {loading ? (
            <TextSkeleton loading={loading} number={1} mt={0} />
          ) : (
            <>
              <Typography className="item-value-text">{value}</Typography>
              <CopyableButton content={value} />
            </>
          )}
        </div>
      </div>
    </StyledReferralCode>
  );
};

export default ReferralCodeItem;
